/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-hls-debug-panel/content-control-studio-hls-debug-panel.component.scss */
.debug-panel {
  position: fixed;
  z-index: 9999;
  width: 420px;
  min-width: 280px;
  min-height: 150px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #1a2530;
  border: 1px solid #3a4a5a;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  font-family:
    "Consolas",
    "Monaco",
    monospace;
  font-size: clamp(11px, 1.4vh, 17px);
  color: #cdd6e0;
  -webkit-user-select: text;
  user-select: text;
  resize: both;
  overflow: hidden;
}
.debug-panel::after {
  content: "";
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 10px;
  height: 10px;
  background:
    linear-gradient(
      135deg,
      transparent 50%,
      #5a6a7a 50%,
      #5a6a7a 55%,
      transparent 55%),
    linear-gradient(
      135deg,
      transparent 65%,
      #5a6a7a 65%,
      #5a6a7a 70%,
      transparent 70%),
    linear-gradient(
      135deg,
      transparent 80%,
      #5a6a7a 80%,
      #5a6a7a 85%,
      transparent 85%);
  pointer-events: none;
  opacity: 0.6;
}
.debug-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background: #232f3a;
  border-bottom: 1px solid #3a4a5a;
  border-radius: 6px 6px 0 0;
  cursor: grab;
}
.debug-header:active {
  cursor: grabbing;
}
.debug-title {
  font-weight: 600;
  font-size: clamp(12px, 1.5vh, 18px);
  color: #e0e6ed;
}
.debug-close {
  background: none;
  border: none;
  color: #8899aa;
  font-size: clamp(14px, 1.7vh, 20px);
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
}
.debug-close:hover {
  color: #ff6b6b;
}
.debug-body {
  overflow-y: auto;
  padding: 4px 0;
}
.debug-section-header {
  background: #2a3644;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: 700;
  font-size: clamp(12px, 1.5vh, 18px);
  color: #7eb8da;
  border-bottom: 1px solid #3a4a5a;
}
.debug-section-header:hover {
  background: #324454;
}
.debug-section {
  padding: 4px 10px;
}
.debug-section + .debug-section {
  border-top: 1px solid #2a3a4a;
}
.debug-section-title {
  font-weight: 700;
  font-size: clamp(11px, 1.4vh, 17px);
  color: #7eb8da;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.debug-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2px 4px;
  gap: 8px;
  border-radius: 3px;
  transition: background-color 0.15s ease;
}
.debug-row:hover {
  background-color: rgba(126, 184, 218, 0.08);
}
.debug-row:hover .debug-label {
  color: #a0b8cc;
}
.debug-row--expandable {
  cursor: pointer;
}
.debug-row--expandable:hover .debug-label {
  color: #bada55;
}
.debug-label {
  color: #8899aa;
  white-space: nowrap;
  flex-shrink: 0;
}
.debug-label[data-tooltip] {
  position: relative;
  cursor: help;
  border-bottom: 1px dotted rgba(136, 153, 170, 0.3);
}
.debug-label[data-tooltip]:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 10000;
  background: #0d1520;
  color: #e0e6ed;
  border: 1px solid #4a5a6a;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: clamp(10px, 1.2vh, 14px);
  font-weight: 400;
  white-space: normal;
  max-width: 300px;
  min-width: 180px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  line-height: 1.4;
  pointer-events: none;
  animation: tooltipFadeIn 0.15s ease;
}
@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.debug-value {
  text-align: right;
  word-break: break-all;
  color: #e0e6ed;
}
.debug-value small {
  color: #6a8a9a;
}
.debug-json {
  background: #141e28;
  color: #bada55;
  padding: 6px 8px;
  border-radius: 3px;
  margin: 2px 0 4px;
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-all;
  font-size: clamp(10px, 1.3vh, 16px);
  line-height: 1.4;
}
/*# sourceMappingURL=content-control-studio-hls-debug-panel.component.css.map */
